import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { Calendar01 } from 'lib/lucky-x-icons-2';
import dayjs from 'dayjs';
import { useToggle } from 'ahooks';
import AddPrpject from '../Add';
import { setCurOperateProject } from 'store/features/projectDetailSlice';
import { useAppDispatch } from 'store/hooks';
import { blockchainUnit } from 'lib/blockChain';

interface IGoogleMintProps {
  largeIcon?: boolean;
  name: string;
  blockchain: string | undefined;
  date: number;
  time: string;
  website: string;
  supply: number;
  wl: number | string;
  publicPrice: string;
  project: any;
}

const GoogleMint: React.FC<IGoogleMintProps> = ({
  largeIcon,
  name,
  blockchain,
  date,
  time,
  website,
  publicPrice,
  supply,
  wl,
  project,
}) => {
  const dispatch = useAppDispatch();
  const [openProject, { toggle, set }] = useToggle(false);

  const supplyCount = useMemo(() => {
    if (!!supply && supply !== 0) {
      return `Supply:+${supply};`;
    } else {
      return '';
    }
  }, [supply]);

  const whitelist_Price = useMemo(() => {
    if ((!wl || wl === '') && Number(wl) !== 0) {
      return '';
    } else if (wl === 0) {
      return '+WL: Free;';
    } else {
      return `+WL:+${wl} ${blockchainUnit(blockchain)};`;
    }
  }, [blockchain, wl]);

  const public_Price = useMemo(() => {
    if ((!publicPrice || publicPrice === '') && Number(publicPrice) !== 0) {
      return '';
    } else if (Number(publicPrice) === 0) {
      return '+Public: Free;';
    } else {
      return `+Public:+${publicPrice} ${blockchainUnit(blockchain)};`;
    }
  }, [blockchain, publicPrice]);

  const mintLocalFormat = useMemo(() => {
    if (!!date && !!time) {
      return dayjs(`${dayjs.utc(date).format('YYYY-MM-DD')}T${time}Z`)
        .utc()
        .local()
        .format('MMMM D, YYYY HH:mm');
    } else if (!!date && !time) {
      return dayjs(date).format('MMMM D, YYYY');
    }
  }, [date, time]);

  let details = '';
  details += `<b>Mint+time:+${mintLocalFormat};</b><br/>`;
  if (website) {
    details += `<b>Official+website:+${website};</b><br/>`;
  }
  details += `<b>${supplyCount}${whitelist_Price}${public_Price}`;

  const googleMintLocalFormat = useMemo(() => {
    if (!!time) {
      return `${dayjs(`${dayjs.utc(date).format('YYYY-MM-DD')}T${time}Z`)
        .utc()
        .local()
        .format('YYYYMMDD[T]HHmmss')}/${dayjs(
        `${dayjs.utc(date).format('YYYY-MM-DD')}T${time}Z`
      )
        .utc()
        .local()
        .add(60, 'minutes')
        .format('YYYYMMDD[T]HHmmss')}`;
    } else {
      return `${dayjs(date).format('YYYYMMDD')}/${dayjs(date).format(
        'YYYYMMDD'
      )}`;
    }
  }, [date, time]);

  const handlerCreate = useCallback(() => {
    if (!!date) {
      const url = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=Minting alert: ${name}&dates=${googleMintLocalFormat}&details=${details}`;
      open(url);
    } else {
      set(true);
      dispatch(setCurOperateProject(project?.id));
    }
  }, [date, name, googleMintLocalFormat, details, set, dispatch, project?.id]);

  return (
    <div
      onClick={handlerCreate}
      className={classNames(
        ' group relative flex cursor-pointer items-center justify-center rounded-full',
        {
          'h-8 w-8 select-none bg-neutral-100 opacity-50 backdrop-blur hover:bg-neutral-400 hover:opacity-100':
            !largeIcon,
          'h-10 w-10 border border-neutral-600 hover:border-neutral-100 ':
            largeIcon,
        }
      )}
    >
      <Calendar01
        size={!largeIcon ? 20 : 24}
        className="text-neutral-400 group-hover:text-neutral-100"
      />
      <div className="absolute -bottom-14 -left-16 z-20  hidden w-[178px] rounded-lg border-2 border-neutral-700 bg-neutral-800 px-2 py-3 text-left text-sm font-normal  text-neutral-200 lg:group-hover:block">
        Add to Google calendar
      </div>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <AddPrpject
          open={openProject}
          onClose={() => {
            set(false);
            dispatch(setCurOperateProject(0));
          }}
          data={project}
        />
      </div>
    </div>
  );
};

export default GoogleMint;
